import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { scAxiosAdmin, thirdparty } from "../..";
import Pagination from "react-js-pagination";
import { ToastContainer, toast } from "react-toastify";
import { API_TOKEN_NAME } from "../../constants";
import Modal from "./DeleteConfirmModalPopup";
import { useLocation, useParams } from "react-router";
import DownloadCSV from "../../utils/DownloadCSV";
import { formatDate } from "../../utils/utils";
const bookingrequest = () => {
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [fatchdata, setFatchdata] = useState([]);
  const [status, setStatus] = useState("Pending");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page
  const [filteredData, setfilteredData] = useState("");
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  useEffect(() => {
    fetchData(); // Initial data fetch
  }, [searchTerm]);

  const fetchData = async () => {
    try {
      let url = window.location.href.split("/");
      let type = url[5];
      let api_endpoint = "";

      if (type == "request") {
        setTitle("Request");
        setType("request_appointment");
        api_endpoint = `/appointments/request_appointment?keyword=${searchTerm}`;
      } else if (type == "booking") {
        setTitle("Booking");
        setType("book_appointment");
        api_endpoint = `/appointments/book_appointment?keyword=${searchTerm}`;
      }

      const response = await thirdparty.get(api_endpoint); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // const handleChange = (keyword) => {
  //   setKeywords(keyword);
  // };

  useEffect(() => {
    const filteredData =
      fatchdata &&
      fatchdata.filter((item) =>
        item["patient_name"]
          ? item["patient_name"]
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
          : ""
      );

    setfilteredData(filteredData);
  }, [fatchdata, searchTerm]);
  // Get current items to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  // Handle search term change
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const modalDeleteConfirmOpen = (e, newStatus, itemId) => {
    setModalDeleteConfirm(true);
    setStatus(newStatus);
    setSelectedItemId(itemId);
  };
  const modalDeleteConfirmClose = () => {
    setModalDeleteConfirm(false);
    setSelectedItemId(null);
  };

  const modalDeleteDepartment = (id) => {
    const data = {
      status: status,
    };

    try {
      if (status === "Delete") {
        const req = scAxiosAdmin
          .delete(`/appointments/${selectedItemId}}`, {
            method: "delete",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((res) => {
            if (res.status === 200) {
              toast.success("Appointment Deleted Successfully!", {
                position: toast.POSITION.TOP_RIGHT,
              });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          })
          .catch((e) => {
            toast.error("Something went wrong!", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          });
      } else {
        const req = scAxiosAdmin
          .put(`/appointment_status/${selectedItemId}`, data, {
            method: "put",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((res) => {
            if (res.status === 200) {
              toast.success("Appointment Status Changed Successfully!", {
                position: toast.POSITION.TOP_RIGHT,
              });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          })
          .catch((e) => {
            toast.error("Something went wrong!", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          });
      }
      setModalDeleteConfirm(false);
      setSelectedItemId(null);
    } catch (e) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-20">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-7">
                            <h4 className="mt-0 header-title">
                              Appointment {title} List
                            </h4>
                          </div>
                          <div className="col-sm-3 text-right">
                            <input
                              className="form-control"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              value={searchTerm}
                              onChange={handleSearch}
                              style={{
                                background: "transparent",
                                border: "none",
                              }}
                            />
                            {/* <a
                              href="/addboardmember"
                              className="btn btn-sm waves-effect waves-light w-50"
                            >
                              Add Board Members
                            </a> */}
                          </div>
                          <div class="col-md-2">
                            <DownloadCSV
                              data={filteredData}
                              fileName="publications_list"
                            />
                          </div>
                          {/* <div className="col-sm-3 text-right">
                            <input
                              type="text"
                              className="form-control border"
                              name="search_keywords"
                              id="search_keywords"
                              value={keywords}
                              onChange={(e) => handleChange(e.target.value)}
                              //   onBlur={this.SearchDepartments}
                              placeholder="Search"
                            />
                          </div> */}
                          <div className="col-sm-3 text-right">
                            {/* <input type="text" className="form-control" name="search_keywords" id="search_keywords" value={this.state.search_keywords} onChange={this.handleChange} onBlur={this.SearchDocotrs} placeholder="Search" /> */}
                          </div>
                          <div className="col-sm-2 text-right">
                            {/* <a href="/addpackage" className="btn btn-sm btn-primary waves-effect waves-light">Add Package</a> */}
                          </div>
                        </div>
                        <div className="table-rep-plugin">
                          <div
                            className="table-responsive b-0"
                            data-pattern="priority-columns"
                          >
                            <table
                              id="tech-companies-1"
                              className="table  table-striped"
                            >
                              <thead>
                                <tr>
                                  {/* <th>Appointment id</th> */}
                                  <th data-priority="1">Type</th>
                                  <th data-priority="4">Patient Name</th>
                                  <th>Patient Number</th>
                                  <th>Doctor Name</th>
                                  <th data-priority="1">Appointment Date</th>
                                  {type === "request_appointment" ? (
                                    ""
                                  ) : (
                                    <th data-priority="1">Time</th>
                                  )}
                                  <th data-priority="1">Applied At</th>
                                  <th data-priority="3">Status</th>
                                  <th data-priority="3">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentItems.length > 0 ? (
                                  currentItems.map(
                                    (item, index) =>
                                      type == item.type && (
                                        <tr key={index}>
                                          <td>{title}</td>
                                          <td>{item.patient_name}</td>
                                          <td>{item.patient_phone_number}</td>
                                          <td>{item.doctor_name}</td>
                                          <td>{item.appointment_date}</td>
                                          {type === "request_appointment" ? (
                                            ""
                                          ) : (
                                            <td>{item.appointment_time}</td>
                                          )}{" "}
                                          <td>{formatDate(item.created_at)}</td>
                                          <td>{item.status}</td>
                                          <td>
                                            {type === "request_appointment" ? (
                                              ""
                                            ) : (
                                              <a
                                                onClick={(e) =>
                                                  modalDeleteConfirmOpen(
                                                    e,
                                                    "Confirmed",
                                                    item.id
                                                  )
                                                }
                                              >
                                                <i
                                                  class="fa-regular fa-calendar-check"
                                                  data-bs-toggle="tooltip"
                                                  data-bs-placement="top"
                                                  title="Approve Request"
                                                ></i>
                                              </a>
                                            )}
                                            <a
                                              onClick={(e) =>
                                                modalDeleteConfirmOpen(
                                                  e,
                                                  "Canceled",
                                                  item.id
                                                )
                                              }
                                            >
                                              <i
                                                className="fa-solid fa-ban"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Cancel Request"
                                              ></i>
                                            </a>
                                            <a
                                              onClick={(e) =>
                                                modalDeleteConfirmOpen(
                                                  e,
                                                  "Delete",
                                                  item.id
                                                )
                                              }
                                            >
                                              <i
                                                className="fa fa-trash"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete Request"
                                              ></i>
                                            </a>

                                            <Modal
                                              show={modalDeleteConfirm}
                                              handleClose={(e) =>
                                                modalDeleteConfirmClose(e)
                                              }
                                            >
                                              <div className="custom_reviews_popup">
                                                <h2 className="text-center">
                                                  Are you sure you wish to
                                                  {status === "Canceled"
                                                    ? " Cancel"
                                                    : status === "Delete"
                                                      ? " Delete"
                                                      : ""}{" "}
                                                  this appointment ?
                                                </h2>
                                                <form
                                                  className="pop-form"
                                                  id="edit_education"
                                                >
                                                  <div className="form-group row">
                                                    <div className="col-sm-3 text-center"></div>
                                                    <div className="col-sm-6 text-center">
                                                      <button
                                                        type="button"
                                                        className="blue_btn_box add_staff_btn mt-5 mr-2"
                                                        onClick={(e) =>
                                                          modalDeleteConfirmClose(
                                                            e
                                                          )
                                                        }
                                                      >
                                                        {" "}
                                                        No
                                                      </button>
                                                      <button
                                                        type="button"
                                                        className="blue_btn_box add_staff_btn mt-5"
                                                        onClick={() =>
                                                          modalDeleteDepartment(
                                                            item.id
                                                          )
                                                        }
                                                      >
                                                        Yes
                                                      </button>
                                                    </div>
                                                    <div className="col-sm-3 text-center"></div>
                                                  </div>
                                                </form>
                                              </div>
                                            </Modal>
                                          </td>
                                        </tr>
                                      )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="8"
                                      className="font_12 txt_col fontweight400 "
                                      style={{ textAlign: "center" }}
                                    >
                                      {" "}
                                      There are currently no bookings.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <Pagination
                              activePage={currentPage}
                              itemsCountPerPage={itemsPerPage}
                              totalItemsCount={
                                filteredData ? filteredData.length : 1
                              }
                              pageRangeDisplayed={5}
                              onChange={handlePageChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default bookingrequest;



// WEBPACK FOOTER //
// ./src/component/admin/bookingrequest.js